import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../util/withRouter';
import { connect } from 'react-redux';
import { PAGES, trackPageView } from '../../../util/mixpanel';

import logo from '../../../assets/img/nave-black-new-logo.svg';
import boardLimit from '../../../assets/img/board-limit.svg'
// Import Style
import '../style.scss';

export class LimitReached extends Component {
  componentDidMount() {
    trackPageView(PAGES.BOARD_LIMIT_REACHED);
  }
  
  render() {
    const { router, user } = this.props;

    return (
      <div className='downtime'>
        <div className='top_header downtime_header'>
          {this.props.outside && <a><img alt="logo" src={logo} /></a>}
          {!this.props.outside && <a href="/"><img alt="logo" src={logo} /></a>}
        </div>

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>You have reached your board limit!</h1>
            <p className='text'>
              <Link className="link_blue" to={`/free${ router.location.search || '' }`}  >
                Remove an existing board
              </Link>{' '}
              or<br/>
              <a href={user.status === 'trial' ? '/subscribe' : '/upgrade'} className="link_blue">
                upgrade your plan
              </a>
            </p>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={boardLimit}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    outside: state.app.outside,
  };
};

export default withRouter(connect(mapStateToProps)(LimitReached));
